import { z } from 'zod';
import { UI_STRINGS } from '@/lib/constants/ui-strings';

const P = UI_STRINGS.PROFILE;

/**
 * Change Password dialog form (mirrors the backend `ChangePasswordDto`
 * validation - the backend re-validates everything regardless).
 */
export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, P.CURRENT_PASSWORD_REQUIRED),
    newPassword: z
      .string()
      .min(8, P.NEW_PASSWORD_TOO_SHORT)
      .regex(/^(?=.*[A-Za-z])(?=.*\d).+$/, P.NEW_PASSWORD_COMPLEXITY),
    confirmNewPassword: z.string().min(1, P.CONFIRM_PASSWORD_REQUIRED),
  })
  .refine((values) => values.newPassword === values.confirmNewPassword, {
    message: P.PASSWORD_MISMATCH,
    path: ['confirmNewPassword'],
  });

export type ChangePasswordFormValues = z.infer<typeof changePasswordSchema>;
